import { Component, OnInit } from '@angular/core';
import { Router, Event, NavigationEnd, RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';

import { ImagePreloaderService } from './services/image-preloader/image-preloader.service';
import { LoaderService } from './services/shared/loader.service';
import { MainService } from 'src/app/services/main/main.service';

import ListServicesDirect from '../assets/json/listServicesAccessDirect.json';
import ListServicesAuth from '../assets/json/listServicesAuth.json';
import { LoaderComponent } from "./shared/loader/loader.component";
import { AuthorizationTypeModalComponent } from "./shared/authorization-type-modal/authorization-type-modal.component";

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    LoaderComponent,
    AuthorizationTypeModalComponent
],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  title = 'AllianzPortal';
  isLoading = true;
  showFooter: boolean = true;

  listServicesDirect: any = ListServicesDirect;
  listServicesAuth: any = ListServicesAuth;

  imgUrlList: string[] = [
    'https://staallianzportalv1dev.blob.core.windows.net/allianz-portal-assets/Vigilado.png'
  ];

  constructor(
    private imagePreloaderService: ImagePreloaderService,
    private loaderService: LoaderService,
    private router: Router,
    private mainService: MainService
  ) {}

  ngOnInit(): void {
    this.ensureSessionId();
    this.loaderService.show();
    this.setImages();

    this.imagePreloaderService.preloadImages(this.imgUrlList)
      .then(() => {
        this.loaderService.hide();
      })
      .catch(error => {
        console.error('Error al cargar las imágenes:', error);
      });

    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {

        console.log(event.url);

        this.mainService.sendEventLog(JSON.stringify({
          action: 'Navigation',
          data: event.url
        })).subscribe();

        this.showFooter = !event.url.toLowerCase().includes('chat?');
      }
    });
  }

  private ensureSessionId(): void {
    const sessionId = sessionStorage.getItem('sessionId');
    if (!sessionId) {
      sessionStorage.setItem('sessionId', crypto.randomUUID());
    }
  }

  setImages() {
    this.listServicesDirect.forEach((x: any) => {
      this.imgUrlList.push(x.image);
    });

    this.listServicesAuth.forEach((x: any) => {
      this.imgUrlList.push(x.image);
    });
  }
}
